import {Component, OnInit} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {Router, RouterLink} from "@angular/router";
import moment from "moment";
import Swal from "sweetalert2";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    RouterLink
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit{

  constructor(
    public authService: AuthService,
    public router: Router
  ) {}

  ngOnInit() {
    const isAuth = this.authService.getIsAuth();
    const currentDate = moment().format('YYYY-MM-DD');

    if (isAuth) {
      this.router.navigate(['/calendario/' + currentDate]);
    }
  }

  onLogin(form: NgForm) {
    if(form.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: "Compila mail e password per accedere",
        confirmButtonColor: '#050A30'
      });

      return;
    }
    this.authService.login(form.value.email, form.value.password);
  }
}
